import LocalizedClientLink from '@modules/common/components/localized-client-link';

const AboutTab = () => (
  <div className="flex flex-col gap-4">
    <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
      Cookies are small text files that can be used by websites to make a
      user&apos;s experience more efficient.
    </p>
    <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
      The law states that we can store cookies on your device if they are
      strictly necessary for the operation of this site. For all other types of
      cookies we need your permission. This site uses different types of
      cookies. Some cookies are placed by third party services that appear on
      our pages.
    </p>
    <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
      You can at any time change or withdraw your consent from the Cookie
      Declaration on our website.
    </p>
    <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
      Learn more about who we are, how you can contact us and how we process
      personal data in our{' '}
      <LocalizedClientLink
        href="/privacy"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Privacy Policy (opens in a new tab)"
        className="font-bold underline decoration-solid text-brand-neutral-900 hover:no-underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-neutral-900"
      >
        Privacy Policy
      </LocalizedClientLink>
      .
    </p>
    <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
      Please state your consent ID and date when you contact us regarding your
      consent.
    </p>
  </div>
);

export default AboutTab;
